import { Component, OnInit } from '@angular/core';

/**
 * Describe the dashboard component
 * @author Vincent Dieltiens <amazon@pm.creativewords.eu>
 */
@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
}
